
import { Spot } from '../spot/Spot'

import {
    createSpots,
    updateSpots,
    deleteSpots
} from '../../../../../store';
import {
    CreateSpotsRequestDto,
    DeleteSpotsRequestDto,
    FlyerPageDto,
    FlyerPageSpotDto,
    UpdateSpotsRequestDto
} from '../../../../../dtos';

import {
    EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE,

    dispatchEventType,
    dispatchEventDataType,
    addEventTypeListener,
    removeEventTypeListener
} from '../../../../../globals/EventDispatcher'


export class SpotsPersistenceManager {

    private _createdSpots?: Array<FlyerPageSpotDto>
    private _updatedSpots?: Array<FlyerPageSpotDto>
    private _deletedSpots?: Array<FlyerPageSpotDto>

    constructor() {

        this.reInit();
    }

    private reInit() {
        this._createdSpots = [];
        this._updatedSpots = [];
        this._deletedSpots = [];
    }

    public prepareSpotsForSaving(dtos: FlyerPageSpotDto[]) {

        this.reInit();

        for (let i = 0; i < dtos.length; i++) {
            let dto = dtos[i]

            if (!dto.hasNumber) {
                // if spot has no number generated from the renumber/renumber from process 
                // => don't use it for create/update/delete methods
                continue
            }

            if (!dto.fpsRecId) {
                this._createdSpots?.push(dto)
            }
            else {
                if (dto.isForDeletion) {
                    this._deletedSpots?.push(dto)
                }
                else {
                    this._updatedSpots?.push(dto)
                }
            }
        }

        let hasNewItems = this._createdSpots!.length > 0 || this._updatedSpots!.length > 0 || this._deletedSpots!.length > 0

        if (hasNewItems) {
            dispatchEventType(EVENT_TYPE_READY_FOR_SPOTS_PERSISTENCY_SAVE)
        }
    }

    private async deleteSpotsAsync(dispatch: any) {
        return new Promise((resolve, reject) => {
            let parsedForDb = DeleteSpotsRequestDto.parseForDB(this._deletedSpots!)
            dispatch(deleteSpots(parsedForDb, (successfull: boolean) => {
                successfull ? resolve(true) : reject(false)
            }));
        })
    }

    private async updateSpotsAsync(dispatch: any, flyerPageDto: FlyerPageDto) {
        return new Promise((resolve, reject) => {
            let parsedForDb = UpdateSpotsRequestDto.parseForDB(this._updatedSpots!, flyerPageDto)
            dispatch(updateSpots(parsedForDb, (successfull: boolean) => {
                successfull ? resolve(true) : reject(false)
            }));
        })
    }

    private async createSpotsAsync(flyerPageId: number, dispatch: any, flyerPage: FlyerPageDto) {
        return new Promise((resolve, reject) => {
            let parsedForDb = CreateSpotsRequestDto.parseForDB(this._createdSpots!, flyerPageId, flyerPage)
            dispatch(createSpots(parsedForDb, (successfull: boolean) => {
                successfull ? resolve(true) : reject(false)
            }));
        })
    }

    public async save(flyerPageId: number, dispatch: any, flyerPageDto: FlyerPageDto) {
        // 1.
        if (this._deletedSpots!.length !== 0) {
            await this.deleteSpotsAsync(dispatch)
        }

        // 2.
        if (this._updatedSpots!.length !== 0) {
            await this.updateSpotsAsync(dispatch, flyerPageDto)
        }

        // 3.
        // createSpots must be called at the end otherwise if we create new spots with existing
        // spot number this will produce errors
        if (this._createdSpots!.length !== 0) {
            await this.createSpotsAsync(flyerPageId, dispatch, flyerPageDto)
        }

        this.reInit();
    }

}